import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { MenuData } from "@royalty/service";
import { Role, Permission, FloorInfo } from "@royalty/model";

export type InteralStateType = {
	[key: string]: any;
};

export const globalEventName = {
	adminMenu: "adminMenu"
};

@Injectable()
export class SharedDataService {
	private _menuDatas: MenuData[];
	public getMenuDatas(): MenuData[] {
		return this._menuDatas;
	}
	public setMenuDatas(value: MenuData[]) {
		this._menuDatas = value;
	}

	private _floors: FloorInfo[];
	public getFloors(): FloorInfo[] {
		return this._floors;
	}
	public setFloors(value: FloorInfo[]) {
		this._floors = value;
	}

	private _roles: Role[];
	public getRoles(): Role[] {
		return this._roles;
	}
	public setRoles(value: Role[]) {
		this._roles = value;
	}

	private _permissions: Permission[];
	public getPermissions(): Permission[] {
		return this._permissions;
	}
	public setPermissions(value: Permission[]) {
		this._permissions = value;
	}


	private _observableState: InteralStateType = new Array<BehaviorSubject<any>>();

	getObservable(key: string): Observable<any> {
		if (!this._observableState[key]) {
			this._observableState[key] = new BehaviorSubject<any>(null);
		}
		return this._observableState[key].asObservable();
	}

	setObservable(key: string, data: any) {
		if (!this._observableState[key]) {
			this._observableState[key] = new BehaviorSubject<any>(null);
		}
		this._observableState[key].next(data);
	}

	unsubscribe(key: string) {
		if (this._observableState[key]) {
			this._observableState[key].unsubscribe();
			this._observableState[key] = null;
		}
	}
}
